import React, { useMemo } from "react";
import { useGetPractices, useCurrentUser } from "utils/hooks";
import { Avatar, Icon, PracticeLogo } from "components";
import { User, Group } from "types";

type Props = {
  patient?: User | null;
  group?: Group | null;
  hidePatientInfo?: boolean;
};

const InfoSection = ({ patient, group, hidePatientInfo }: Props) => {
  const { practices } = useGetPractices();
  const { user } = useCurrentUser();

  const logo = useMemo(
    () =>
      practices && practices[0] && practices[0].logoUrl
        ? practices[0].logoUrl
        : "",
    [practices]
  );

  const getUserName = (u: User | null) => {
    if (!u) return "";
    const firstName = u?.firstName ? `${u?.firstName} ` : "";
    const lastName = u?.lastName ? u?.lastName : "";
    return firstName + lastName;
  };

  return (
    <div className="fill-modal_info">
      <section className="fill-modal_info_therapist">
        {logo && <PracticeLogo image={logo} position="left" />}
        {user?.fullName ? user.fullName : getUserName(user)}
      </section>

      {!hidePatientInfo && (
        <>
          <section className="fill-modal_info_section">
            <div className="fill-modal_info_image">
              <div className="fill-modal_info_avatar">
                <Avatar user={patient} />
              </div>
            </div>
            <span className="fill-modal_info_name">
              {patient?.fullName
                ? patient.fullName
                : getUserName(patient || null)}
            </span>
          </section>

          <section className="fill-modal_info_section">
            <div className="fill-modal_info_image">
              <div className="fill-modal_info_icon">
                <Icon src={"Envelope"} />
              </div>
            </div>
            <span className="fill-modal_info_email">{patient?.email}</span>
          </section>

          {patient?.profile?.idNumber && (
            <section className="fill-modal_info_section">
              <div className="fill-modal_info_image">
                <div className="fill-modal_info_icon">
                  <Icon src={"IdCard2"} />
                </div>
              </div>
              <span className="fill-modal_info_text">
                {patient.profile.idNumber}
              </span>
            </section>
          )}

          {group && (
            <section className="fill-modal_info_section">
              <div className="fill-modal_info_image">
                <div className="fill-modal_info_icon">
                  <Icon src={"Group2"} />
                </div>
              </div>
              <span className="fill-modal_info_text">{group?.name}</span>
            </section>
          )}
        </>
      )}
      <div className="fill-modal_info_brand">reflective</div>
    </div>
  );
};

export default InfoSection;
